import { configureStore } from "shared/store";
import { isAdminApp } from "shared/utils/auth";

const createStore = () => (isAdminApp() ? configureStore() : null);

export default createStore;
